import 'core-js/proposals/reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

class PerfilDTOGenerico2 extends Serializable {
    @jsonProperty(Number)
    id: number = -1;

    @jsonProperty(String)
    nome: string = '';

    constructor() {
        super();
    }
}

export default PerfilDTOGenerico2;
